const KukiAccordion = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.pageMenu = document.getElementsByClassName('menu');
        if (DOM.pageMenu.length > 0) {
            DOM.children = DOM.pageMenu[0].children;
            DOM.subMenus = DOM.pageMenu[0].getElementsByClassName('menu-item-has-children');
        }
    };

    const noJs = () => {
        for (let i = 0; i < DOM.subMenus.length; i += 1) {
            if (DOM.subMenus[i].classList.contains('menu-item-has-children')) {
                if (DOM.subMenus[i].children[1]) {
                    closeMenu(DOM.subMenus[i].children[1])
                }
            }
        }
    };

    const closeMenu = (subMenu) => {
       subMenu.style.height = "0";
    };

    function openSubMenu(event) {
        let height = event.target.nextElementSibling.scrollHeight;

        let subMenuParent =  event.target.parentElement.parentElement;
        let subMenuParentHeight = event.target.parentElement.parentElement.offsetHeight;

        if (!event.target.classList.contains('active')) {
            event.preventDefault();
        }

        for (let i = 0; i < DOM.subMenus.length; i++) {
            DOM.subMenus[i].firstElementChild.classList.remove('active');
            DOM.subMenus[i].lastElementChild.setAttribute(
              "style",
              `height: 0;`
            );
        }

        event.target.classList.add('active');
        event.target.nextElementSibling.setAttribute(
          "style",
          `
            height: ${height}px;
            display: block;
        `
        );

        if (subMenuParent.classList.contains('sub-menu')) {
            let height = subMenuParentHeight + event.target.nextElementSibling.scrollHeight;

            subMenuParent.parentElement.firstElementChild.classList.add('active');
            subMenuParent.setAttribute(
              "style",
              `
               height: ${height}px;
               `
            );
        }
    }

    const setupEventListeners = () => {
        for (let i = 0; i < DOM.subMenus.length; i++) {
            DOM.subMenus[i].addEventListener('click', function (event) {
                console.log('Class: , Function: , Line: 71 ', DOM.subMenus[i]);
                if (event) {
                    openSubMenu(event);
                }
            });
        }
    };

    const init = () => {
        cacheDOM();
        if (DOM.pageMenu.length > 0) {
            setupEventListeners();
            noJs();
        }
    };

    return {init};

})();

export default KukiAccordion;
